import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SidebarProvider } from 'contexts/SidebarContext';
// import { Footer } from './Footer';

interface AppLayoutProps {
  children?: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <SidebarProvider>
      <div className="min-h-screen bg-background">
        <div className="flex h-screen">
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content */}
          <div className="flex-1 flex flex-col overflow-hidden">
            <Header />

            {/* Page Content */}
            <main className="flex-1 overflow-y-auto p-6">{children || <Outlet />}</main>
          </div>
        </div>

        {/* Footer */}
        {/* <Footer /> */}
      </div>
    </SidebarProvider>
  );
};
